<template>
  <div :class="$style.container" @click.stop>
    <!-- Лимиты на количество выводов шлюза (если есть) -->
    <template v-if="limited">
      <div
        v-m-b="5"
        :class="$style.section"
      >
        <span
          v-m-r="5"
          :class="$style.label"
          v-text="$t('card.item.month.payouts')"
        ></span>
        <span
          :class="[
            $style.value,
            { [$style.empty]: isEmptyPayoutCount },
          ]"
          v-text="displayPayoutCounts"
        ></span>
      </div>
    </template>

    <!-- Шкала прогресса выводов средств -->
    <!-- Отображаем засечки только при наличии лимитов выводов шлюза -->
    <payout-progress-bar
      v-m-b="5"
      :loading="loading"
      :payout-sums="payoutSums"
      :is-filled="isFilledProgress"
    />

    <div
      v-d-flex
      v-justify="{ content: 'space-between' }"
      :class="$style.section"
    >
      <div :class="$style.leftSide">
        <span
          :class="$style.label"
          v-text="$t('card.item.paid')"
        ></span>
        <span
          :class="$style.value"
          v-text="displayActualAmount"
        ></span>
      </div>

      <div :class="$style.rightSide">
        <span
          :class="$style.label"
          v-text="$t('card.item.more.possible')"
        ></span>
        <span
          :class="[
            $style.value,
            { [$style.empty]: isEmptyPayoutAmount },
          ]"
          v-text="displayAvailableAmount"
        ></span>
      </div>
    </div>

    <div v-if="limits.limitsExceeded && isNotifying" :class="$style.notice">
      <div :class="$style.text" v-text="$t('card.item.next.payout.availability')" />
      <div :class="$style.date" v-text="displayDate" />
    </div>
  </div>
</template>

<script>
import { formatAmount } from 'lib/utils/amount';
import { calcPercent } from 'lib/utils/number';
import { formatDateToCustomDateFormat } from 'lib/utils/date';

import PayoutProgressBar from 'organisms/payout/components/PayoutProgressBar';

export default {
  name: 'PayoutLimits',
  components: {
    PayoutProgressBar,
  },
  props: {
    currency: {
      type: Object,
      required: true,
    },
    limits: {
      type: Object,
      required: true,
    },
    loading: Boolean,
    isNotifying: Boolean,
  },
  computed: {
    limited() {
      return this.limits.limited;
    },
    isEmptyPayoutAmount() {
      return this.limits.payoutSumLeft === 0;
    },
    isEmptyPayoutCount() {
      if (!this.limited) {
        return false;
      }

      return this.limits.payoutCountActual === this.limits.payoutCountLimit;
    },
    displayPayoutCounts() {
      if (!this.limited) {
        return null;
      }

      return `${this.limits.payoutCountActual} / ${this.limits.payoutCountLimit}`;
    },
    displayActualAmount() {
      return formatAmount(this.limits.payoutSumActual, this.currency);
    },
    displayAvailableAmount() {
      return formatAmount(this.limits.payoutSumLeft, this.currency);
    },
    isFilledProgress() {
      return this.isEmptyPayoutCount || this.isEmptyPayoutAmount;
    },
    payoutSums() {
      if (this.loading) {
        return [];
      }

      return this.limits.payoutSums
        .map(sum => calcPercent(sum, this.limits.payoutSumLimit));
    },
    displayDate() {
      return formatDateToCustomDateFormat(this.limits.nextPayoutDate, 'DD.MM.YYYY');
    },
  },
};
</script>

<style lang="sass" module>
  .container
    position: relative

  .section
    +font-type('regular', 12, 16)
    color: var(--color-white)

  .label
    opacity: 0.5

  .value

    &.empty
      +font-weight('bold')
      color: var(--color-red)

  .leftSide
    +flexbox
    +flex-direction(column)

    +respond-to('small')
      +flex-direction(row)

      .label
        order: 1

      .value
        margin-right: 5px

  .rightSide
    +flexbox
    +flex-direction(column)
    +align-items(flex-end)

    +respond-to('small')
      +flex-direction(row)

      .value
        margin-left: 5px

  .notice
    +inline-flex
    +justify-content(space-between)
    width: 100%
    margin-top: 15px
    border-radius: 5px
    padding: 10px
    background-color: var(--color-dark-blue-3)

  .text
    +flexbox
    +align-items(center)
    +font-type('regular', 12, 17)

  .date
    +flexbox
    +align-items(center)
    margin-left: 10px
    padding: 5px 10px
    border-radius: 5px
    +font-type('bold', 11, 15)
    background: linear-gradient(249.76deg, #24A84D -8.32%, #068ACC 108.85%), rgba(255, 255, 255, 0.5)
    white-space: nowrap
</style>
